/**
 * KanbanBanner — 0258 D1: Mensaje cuando Kanban sin Agenda activa
 * Muestra banner informativo para activar Agenda y obtener columnas por perfil.
 */
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Paper, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SettingsIcon from "@material-ui/icons/Settings";

const useStyles = makeStyles((theme) => ({
  banner: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.warning.light,
    borderLeft: `4px solid ${theme.palette.warning.main}`,
  },
  title: { fontWeight: 600, marginBottom: theme.spacing(1) },
  text: { color: theme.palette.text.secondary, marginBottom: theme.spacing(2) },
  button: { marginTop: theme.spacing(1) },
}));

export default function KanbanBanner() {
  const classes = useStyles();
  return (
    <Paper className={classes.banner} elevation={0}>
      <Typography variant="subtitle1" className={classes.title}>
        Kanban sin configuración de Agenda
      </Typography>
      <Typography variant="body2" className={classes.text}>
        Activa Agenda en Configuración para ver columnas por perfil (Solicitud Recibida,
        Cita Confirmada, Cita Completada, etc.). Las columnas Kanban se crean
        automáticamente según tu tipo de negocio.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={<SettingsIcon />}
        component={RouterLink}
        to="/appointments"
        className={classes.button}
        aria-label="Ir a Configuración de Agenda"
      >
        Activar Agenda en Configuración
      </Button>
    </Paper>
  );
}
